import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc315010"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formal-open-detail" }
const _hoisted_2 = { class: "item-first formal-open-detail" }
const _hoisted_3 = { class: "item text-overflow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司名称：", -1))
const _hoisted_5 = { class: "item text-overflow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "联系电话：", -1))
const _hoisted_7 = { class: "item text-overflow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户银行：", -1))
const _hoisted_9 = { class: "formal-open-detail" }
const _hoisted_10 = {
  class: "item text-overflow",
  style: {"width":"300px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "银行账户号码：", -1))
const _hoisted_12 = { class: "item text-overflow" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 税号：", -1))
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "正式开业时间：", -1))
const _hoisted_16 = { class: "formal-open-detail item-last" }
const _hoisted_17 = { class: "long-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "地址：", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1))

import HeadTitle from "@/components/HeadTitle.vue";
import { detail } from "@/api/process_open";
import {
  withDefaults,
  watch,
  onMounted,
  ref,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }




watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const Id = ref<number>(0);
const CompanyName = ref<string>("");
const ContactPhone = ref<string>("");
const TaxNo = ref<string>("");
const OpenAccountBank = ref<string>("");
const BankAccount = ref<string>("");
const Address = ref<string>("");
const GrandOpenTime = ref<string>("");

const getdata = async () => {
  const { Data } = await detail({
    Id: props.folwId,
  });

  Id.value = Data?.Id || "";
  CompanyName.value = Data?.CompanyName || "";
  ContactPhone.value = Data?.ContactPhone || "";
  TaxNo.value = Data?.TaxNo || "";
  BankAccount.value = Data?.BankAccount || "";
  Address.value = Data?.Address || "";
  OpenAccountBank.value = Data?.OpenAccountBank || "";
  GrandOpenTime.value = Data?.GrandOpenTime || "";
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeadTitle, {
        title: "正式开业申请",
        style: {"margin-top":"24px"}
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(CompanyName.value), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(ContactPhone.value), 1)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(OpenAccountBank.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, _toDisplayString(BankAccount.value), 1)
      ]),
      _createElementVNode("span", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", null, _toDisplayString(TaxNo.value), 1)
      ]),
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(GrandOpenTime.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("span", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", null, _toDisplayString(Address.value), 1)
      ])
    ]),
    _hoisted_19
  ], 64))
}
}

})